<template>
    <b-button :variant="btnVariant"
              :disabled="loading"
              @click="whenClick">
        <b-spinner small v-if="loading"></b-spinner>
        <slot></slot>
    </b-button>
</template>

<script>
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "DownloadButton",
    mixins: [emCommonUtilMixin],
    props: {
        url: {
            type: String,
            required: true
        },
        fileName: {
            type: String,
            required: true
        },
        btnVariant: {
            type: String,
            default: 'outline-success'
        }
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        whenClick() {
            this.loading = true;
            this.downloadWithHeader(this.url, this.fileName, () => this.loading = false);
        },
    }
}
</script>

<style scoped>

</style>